module.exports = __webpack_public_path__ + "img/car.7f47ca3f.svg";